import { render, staticRenderFns } from "./ClaimFormList.vue?vue&type=template&id=10637128&"
import script from "./ClaimFormList.vue?vue&type=script&lang=js&"
export * from "./ClaimFormList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports